module.exports = __webpack_public_path__ + "img/lf2.dec86451.png";